<template>
    <ion-menu content-id="main-content" v-if="isLogged">
        <ion-header>
            <ion-toolbar>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ion-list class="menu-profile-info">
                <ion-item lines="none">
                    <img :src="profilePhoto" />
                </ion-item>
                <ion-item lines="none">
                    <div class="menu-profile-name">{{profileName}}</div>
                </ion-item>
                <ion-item lines="none" class="languageSelectorContainer" v-if="systemVersion == 'pl'">
                    <ion-icon :icon="languageOutline"></ion-icon>
                    <ion-select :placeholder="$t('selectLanguage')" v-model="selectedLanguage" @ionChange="switchLang($event.detail.value)" interface="action-sheet" mode="ios" :cancelText="$t('Cancel')" v-if="systemVersion == 'pl'">
                        <ion-select-option v-for="(item, key) in languagesOptions" :key="key" :value="key" style="color: #000000;">{{ item }}</ion-select-option>
                    </ion-select>
                    <ion-select :placeholder="$t('selectLanguage')" v-model="selectedLanguage" @ionChange="switchLang($event.detail.value)" interface="action-sheet" mode="ios" :cancelText="$t('Cancel')" v-else>
                        <ion-select-option v-for="(item, key) in languagesOptions" :key="key" :value="key" style="color: #ffffff;">{{ item }}</ion-select-option>
                    </ion-select>
                </ion-item>
            </ion-list>
            <ion-list>
                <ion-menu-toggle>
                    <ion-item lines="none" router-link="/">
                        <ion-label>{{ $t('homeScreen') }}</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-accordion-group :multiple="false" ref="menuAccordionGroup" class="menu-accordion">
                    <ion-accordion value="working" v-if="isAgent">
                        <template v-if="systemVersion == 'hu'">
                            <ion-item slot="header">
                                <ion-label>{{ $t('working') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" v-if="isAgent" class="sub" @click="createNewContract()">
                                <ion-label>{{ $t('newContract') }}</ion-label>
                            </ion-item>
<!--                            <ion-item slot="content" lines="none" v-if="isAgent && systemVersion == 'pl'" @click="bePatient()" class="sub">-->
<!--                                <ion-label>{{ $t('newContract') }}</ion-label>-->
<!--                            </ion-item>-->
                            <ion-item slot="content" lines="none" router-link="/newShowing/startNew" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('newShowing') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/newBuyer/startNew" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('newBuyer') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/reservations" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('phoneModule') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/reservations/list" v-if="isAgent && systemVersion == 'pl'" class="sub" @click="closeMenu()">
                              <ion-label>{{ $t('phoneModuleList') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/priceChange" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('priceChange') }}</ion-label>
                            </ion-item>
<!--                            <ion-item slot="content" lines="none" router-link="/leaderboard" v-if="isAgent && systemVersion == 'pl'" class="sub" @click="closeMenu()">-->
                            <ion-item slot="content" lines="none" router-link="/leaderboard" v-if="isAgent" class="sub" @click="closeMenu()">
                              <ion-label>{{ $t('leaderboard') }}</ion-label>
                            </ion-item>
                        </template>
                        <template v-else>
                            <ion-item slot="header">
                                <ion-label>{{ $t('working') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/newShowing/startNew" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('newShowing') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/reservations" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('phoneModule') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/newBuyer/startNew" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('newBuyer') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" v-if="isAgent" class="sub" @click="createNewContract()">
                                <ion-label>{{ $t('newContract') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/priceChange" v-if="isAgent" class="sub" @click="closeMenu()">
                                <ion-label>{{ $t('priceChange') }}</ion-label>
                            </ion-item>
                            <ion-item slot="content" lines="none" router-link="/reservations/list" v-if="isAgent && systemVersion == 'pl'" class="sub" @click="closeMenu()">
                              <ion-label>{{ $t('phoneModuleList') }}</ion-label>
                            </ion-item>
<!--                            <ion-item slot="content" lines="none" router-link="/leaderboard" v-if="isAgent && systemVersion == 'pl'" class="sub" @click="closeMenu()">-->
                            <ion-item slot="content" lines="none" router-link="/leaderboard" v-if="isAgent" class="sub" @click="closeMenu()">
                              <ion-label>{{ $t('leaderboard') }}</ion-label>
                            </ion-item>
                        </template>
                    </ion-accordion>
                    <ion-accordion value="search">
                        <ion-item slot="header">
                            <ion-label>{{ $t('search') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" @click="openModule('propertiesSearch'); closeMenu()" class="sub">
                            <ion-label>{{ $t('propertySearch') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/dashboard" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('dashboard') }}</ion-label>
                        </ion-item>
                        <ion-item v-if="systemVersion === 'hu'" slot="content" lines="none" router-link="/duoCalculator" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('duoCalculator') }}</ion-label>
                        </ion-item>
                        <ion-item v-if="systemVersion === 'hu'" slot="content" lines="none" router-link="/systemMessages" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('systemMessages.title') }}</ion-label>
                        </ion-item>
                    </ion-accordion>
                    <ion-accordion value="savedItems" v-if="isAgent">
                        <ion-item slot="header">
                            <ion-label>{{ $t('savedItems') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/drafts" v-if="isAgent" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('savedDrafts') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/savedContracts" v-if="isAgent" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('submittedContracts') }}</ion-label>
                        </ion-item>
                    </ion-accordion>
                    <ion-accordion value="profile">
                        <ion-item slot="header">
                            <ion-label>{{ $t('profile') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/notifications" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('notifications') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/changeIdentity" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('changeIdentity') }}</ion-label>
                        </ion-item>
                        <ion-item slot="content" lines="none" router-link="/loginRequests" class="sub" @click="closeMenu()">
                            <ion-label>{{ $t('loginRequests') }}</ion-label>
                        </ion-item>
                    </ion-accordion>
                </ion-accordion-group>
                <ion-menu-toggle>
                    <ion-item lines="none" @click="requestLogout()" class="logout-button">
                        <ion-label>{{ $t('logout') }}</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ion-list>
        </ion-content>
    </ion-menu>
</template>

<script>
/* eslint-disable */
import {
    IonAlert,
    IonButton,
    IonMenu,
    IonHeader,
    IonToolbar,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonMenuToggle,
    IonSelect,
    IonSelectOption,
    IonIcon,
    alertController,
    IonAccordionGroup, IonAccordion, IonGrid, IonCard, IonCol, IonCardContent
} from '@ionic/vue';
import {clearBiometricDatas, redirectWithoutLottie, getSystemVersion} from '../../js/functions.js';
import {userIsAgent, userIsLoggedIn} from '../../js/users.js';
import {Languages} from '../../js/languages.class.js';
import {languageOutline} from 'ionicons/icons';
import axios from "axios";

export default {
    components: {
        IonCardContent,
        IonCol,
        IonCard,
        IonAlert,
        IonButton,
        IonGrid,
        IonAccordion,
        IonAccordionGroup,
        IonMenu, IonHeader, IonToolbar, IonContent, IonList, IonItem, IonLabel, IonMenuToggle, IonSelect, IonSelectOption, IonIcon},
    
    data() {
        let languagesClass = new Languages;

        return {
            profilePhoto: '',
            profileName: '',
            isLogged: userIsLoggedIn(),
            isAgent: userIsAgent(),
            languagesClass: languagesClass,
            selectedLanguage: languagesClass.getSelectedLanguage(),
            languagesOptions: languagesClass.getSupportedLanguages(),
            systemVersion: getSystemVersion(),

            //ICONS
            languageOutline
        }
    },

    mounted() {
        console.log('dhMenu.vue mounted');
        console.log(this.isLogged);
        this.getLoginDatas();
    },
    watch: {
        '$route'() {
            this.getLoginDatas();
        }
    },

    methods: {
        setOpenLogoutDialog(state) {
          this.isOpenLogoutDialog.value = state;
        },
        async requestLogout() {
            const alert = await alertController.create({
              header: this.$t('areYouSureYouWantLogout'),
              buttons: [
                {
                  text: this.$t('cancel'),
                  role: 'cancel',
                  handler: () => {
                  },
                },
                {
                  text: this.$t('ok'),
                  role: 'confirm',
                  handler: () => {
                    window.location.href = '/login';
                    clearBiometricDatas();
                    localStorage.clear();
                  },
                },
              ],
            });
            await alert.present();
        },
        getLoginDatas() {
            let selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
            let loginDatas = JSON.parse(localStorage.getItem('loginDatas'));

            this.profilePhoto = (selectedIdentity != null) ? selectedIdentity.photo.replace('http://', 'https://') : '';
            this.profileName = (loginDatas != null) ? loginDatas.fullName : '';
        },
        switchLang(_lang) {
            if (this.languagesClass.setLanguage(_lang)) {
                window.location.href = '/';
            }
        },
        openModule(moduleStr) {
            redirectWithoutLottie(`/${moduleStr}`);
        },
        closeMenu() {
            const menu = document.querySelector('ion-menu');
            menu.close();
        },
        async bePatient() {
            let alert;
            let self = this;
            alert = await alertController.create({
                header: self.$t('information'),
                message: self.$t('theModuleWillAvailableSoon'),
                buttons: ['OK'],
            });
            alert.present();
        },
        async createNewContract() {
            const alert = await alertController.create({
                header: this.$t('confirmNewContractWithoutReservation'),
                buttons: [
                    {
                        text: this.$t('yesStartContract'),
                        handler: () => {
                            this.executeCreateNewContract();
                        }
                    },
                    {
                        text: this.$t('goToReservation'),
                        handler: () => {
                            this.closeMenu();
                            this.$router.push('/reservations/list');
                        }
                    },
                    {
                        text: this.$t('cancel'),
                        role: 'cancel'
                    }
                ]
            });
            await alert.present();
        },
        async executeCreateNewContract() {
            let addNewContract = true;
            if(this.systemVersion === 'pl') {
                addNewContract = false;
                try {
                    let self = this;
                    let selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
                    const response = await axios.post(this.APIURL('canAddNewContract'), {identityId: selectedIdentity.id}, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    if(typeof response.data.hasDocument == "undefined" || response.data.hasDocument == false) {
                        let alert = await alertController.create({
                            header: self.$t('error'),
                            message: response.data.message,
                            buttons: [{
                                text: 'OK',
                            }],
                        });
                        alert.present();
                        addNewContract = false;
                    }
                    else {
                        addNewContract = true;
                    }
                } catch (error) {
                    console.error('Error polling server:', error);
                }
            }

            if(addNewContract) {
                this.closeMenu();
                this.$router.push('/newContract/startNew');
            }
        }
    }
}
</script>

<style scoped>
ion-select {
    --padding-start: 0px;
    --padding-bottom: 0px;
    --padding-top: 0px;
    width: fit-content;
}
ion-select::part(text) {
    color: #ffffff;
}
.metro ion-select::part(text) {
    color: #000000;
}
ion-select::part(icon) {
    color: #ffffff;
}
.metro ion-select::part(icon) {
    color: #000000;
}
.languageSelectorContainer {
    display: flex;
    align-items: center;
    justify-content: center;
}
.languageSelectorContainer ion-icon {
    color: #ffffff;
    margin-right: 10px;
    font-size: 20px;
}
.metro .languageSelectorContainer ion-icon {
    color: #000000;
    margin-right: 10px;
    font-size: 20px;
}
</style>